/// <reference types="@angular/localize" />

import localeNl from '@angular/common/locales/nl-BE';
import { bootstrapApplication } from '@angular/platform-browser';

import { App } from './app/app';
import { APP_CONFIG } from './app/app.config';

import './openTelemetry/instrument.ts';

import { registerLocaleData } from '@angular/common';

bootstrapApplication(App, APP_CONFIG).catch((err) => console.error(err));
registerLocaleData(localeNl);
